import React from 'react'
import { StyleSheet } from 'react-native';

import { DNAText, DNABox, DNAButton, Iffy } from "@alucio/lux-ui"

import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import useCurrentPage from 'src/components/DNA/hooks/useCurrentPage';
import HubsStateProvider, { HubVariant, useHubsState } from 'src/state/context/Hubs/HubsStateProvider';
import HubsTable from 'src/components/Hubs/HubsTable';
import EditHubWrapper from 'src/screens/Hubs/EditHub/EditHub';
import { useParams } from 'react-router';
import HubsTemplateEmptyState from 'src/components/DNA/Empty/HubsTemplateEmptyState';
import HubsTemplateHeader from 'src/components/Hubs/HubsTemplateHeader';

const styles = StyleSheet.create({
  mainWrapper: {
    backgroundColor: colors['color-text-white'],
    minHeight: 'calc(100vh - 160px)',
    overflowX: 'auto',
  },
})

const HubsTemplateList = () => {
  const currentPage = useCurrentPage()
  const { hubsORM } = useHubsState()

  return (
    <DNABox style={styles.mainWrapper} appearance="col">
      { /* HEADER */}
      <DNABox appearance="col">
        <HubsTemplateHeader
          title={currentPage?.LABEL || ''}
          description="Create hub templates for your audience"
        />
      </DNABox>
      { /* TEMPLATES LIST */}
      <DNABox testID="email-template-list" fill>
        {/* The reason we are passing empty component instead of just checking here is
        that from the mocks we need the table header if there are no templates */}
        <HubsTable emptyComponent={!hubsORM.length && <HubsTemplateEmptyState />} />
        <EditHubWrapper />
      </DNABox>
    </DNABox>
  )
}

const HubsTemplateWrapper: React.FC = () => {
  const { hubId } = useParams<{ hubId: string }>()

  return (
    <HubsStateProvider hubId={hubId} variant={HubVariant.TEMPLATE}>
      <HubsTemplateList />
    </HubsStateProvider>
  )
}

export default HubsTemplateWrapper;